import { defineNuxtPlugin } from "#imports";
let youtubeIframeApiPromise = null;
const YT_API_SRC = "https://www.youtube.com/iframe_api";
const YT_API_TIMEOUT_MS = 10000;

export default defineNuxtPlugin({
  name: "youtube-iframe-api",
  enforce: "pre",

  setup(nuxtApp) {
    const loadYouTubeIframeApi = () => {
      if (typeof window === "undefined") {
        return Promise.reject(new Error("YouTube API can only load in browser"));
      }
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (youtubeIframeApiPromise) return youtubeIframeApiPromise;

      youtubeIframeApiPromise = new Promise((resolve, reject) => {
        let isDone = false;
        const finish = (error) => {
          if (isDone) return;
          isDone = true;
          clearTimeout(timeoutId);
          if (error) {
            youtubeIframeApiPromise = null;
            reject(error);
            return;
          }
          resolve(window.YT);
        };

        const timeoutId = window.setTimeout(
          () => finish(new Error("YouTube iframe API load timeout")),
          YT_API_TIMEOUT_MS,
        );

        const previousReady = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (typeof previousReady === "function") previousReady();
          finish();
        };

        const existingScript = document.querySelector(`script[src="${YT_API_SRC}"]`);
        if (existingScript) return;

        const script = document.createElement("script");
        script.src = YT_API_SRC;
        script.async = true;
        script.onerror = () => finish(new Error("Failed to load YouTube iframe API"));
        document.head.appendChild(script);
      });

      return youtubeIframeApiPromise;
    };

    nuxtApp.provide("youtubeIframeApi", {
      loadYouTubeIframeApi,
    });
  },
});
